import { X } from 'lucide-react'
import { type AssetFolder } from '../lib/api'

interface MoveToFolderModalProps {
  folders: AssetFolder[]
  assetCount: number
  onConfirm: (folderId: string | null) => void
  onClose: () => void
}

export default function MoveToFolderModal({ folders, assetCount, onConfirm, onClose }: MoveToFolderModalProps) {
  const label = assetCount === 1 ? '1 file' : `${assetCount} files`

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center">
      <div className="absolute inset-0 bg-black/70" onClick={onClose} />
      <div className="relative z-10 bg-zinc-900 border border-zinc-700 rounded-xl w-full max-w-xs mx-4 overflow-hidden">
        <div className="flex items-center justify-between px-4 py-3 border-b border-zinc-800">
          <h2 className="text-sm font-medium text-white">Move {label} to…</h2>
          <button type="button" onClick={onClose} className="text-zinc-500 hover:text-white transition-colors">
            <X size={15} />
          </button>
        </div>
        <div className="p-2 max-h-72 overflow-y-auto">
          <button type="button"
            onClick={() => onConfirm(null)}
            className="w-full text-left px-3 py-2 rounded text-sm text-zinc-300 hover:bg-zinc-700 hover:text-white transition-colors"
          >
            📁 All Files (no folder)
          </button>
          {folders.map((folder) => (
            <button type="button"
              key={folder.id}
              onClick={() => onConfirm(folder.id)}
              className="w-full text-left px-3 py-2 rounded text-sm text-zinc-300 hover:bg-zinc-700 hover:text-white transition-colors"
            >
              📁 {folder.name}
            </button>
          ))}
          {folders.length === 0 && (
            <p className="px-3 py-4 text-zinc-500 text-xs text-center">No folders yet. Create one first.</p>
          )}
        </div>
      </div>
    </div>
  )
}
